module.exports = __webpack_public_path__ + "static/media/landing.1e388c68.svg";